module.exports = __webpack_public_path__ + "img/download-on-the-app-store-nb.fb752197.svg";